import { useState, useCallback } from 'react'

/**
 * Hook for managing polygon drawing state
 * Coordinates are in CRS.Simple pixel format { y, x }
 */
export const usePolygonDraw = () => {
  const [points, setPoints] = useState([])
  const [cursorPosition, setCursorPosition] = useState(null)
  const [isComplete, setIsComplete] = useState(false)

  const isDrawing = points.length > 0 && !isComplete

  const addPoint = useCallback((latlng) => {
    if (isComplete) return
    setPoints(prev => [...prev, { y: latlng.lat, x: latlng.lng }])
  }, [isComplete])

  const undoPoint = useCallback(() => {
    if (isComplete) {
      // If complete, reopen for editing by removing completion state
      setIsComplete(false)
      return
    }
    setPoints(prev => prev.slice(0, -1))
  }, [isComplete])

  const closePolygon = useCallback(() => {
    if (points.length < 3) return
    setIsComplete(true)
    setCursorPosition(null)
  }, [points.length])

  const resetDrawing = useCallback(() => {
    setPoints([])
    setCursorPosition(null)
    setIsComplete(false)
  }, [])

  const updateCursor = useCallback((latlng) => {
    if (isComplete) return
    setCursorPosition(latlng ? { y: latlng.lat, x: latlng.lng } : null)
  }, [isComplete])

  return {
    points,
    cursorPosition,
    isComplete,
    isDrawing,
    addPoint,
    undoPoint,
    closePolygon,
    resetDrawing,
    updateCursor,
  }
}
